// extracted by mini-css-extract-plugin
module.exports = {"belongStandards":"belong-standards-landing-link_belongStandards__SsIY3"};